

















































































































































































































import { Component, Vue } from 'vue-property-decorator';

import { Customer, InputError, ResponseCodeEnum, Utils } from '@/models';

import { toastService, customerService, tireStoringContractService } from '@/services';

import SearchCustomerComponent from '@/components/customer/SearchCustomerComponent.vue'

// @ts-ignore
import postal_code from 'japan-postal-code';

@Component({
  components: {
    SearchCustomerComponent,
  }
})
export default class UserRegisterInputPage extends Vue {
  private data: Customer = new Customer();
  private tireContractId!: string;
  private agencyId!: string;
  private options: any = [];
  private showModal: boolean = false;
  private showSearchCustomer: boolean = false;
  private errors: InputError[] = [
    { field: 'name', isError: undefined, message: [] },
    { field: 'furigana', isError: undefined, message: [] },
    { field: 'phoneNumber', isError: undefined, message: [] },
    { field: 'phoneType', isError: undefined, message: [] },
    { field: 'mobileNumber', isError: undefined, message: [] },
    { field: 'postalCode', isError: undefined, message: [] },
    { field: 'address1', isError: undefined, message: [] },
    { field: 'address2', isError: undefined, message: [] },
    { field: 'emailAddress', isError: undefined, message: [] },
  ];
  private isConfirm: boolean = false;
  private province: string = '';
  private district: string = '';
  private showProvince: boolean = false;
  private showModalConfirm: boolean = false;
  private showModalConfirmInfo: boolean = false;
  private created() {
    this.loadPhoneType();
    this.agencyId = Utils.getQueryParam(this.$route.query['agencyId']);
    if (this.$route.query['contractId']) {
      const contractId: any = this.$route.query['contractId'];
      tireStoringContractService.get(contractId)
        .then((res) => {
          if (res.data.code === ResponseCodeEnum.CODE_SUCCESS
              && res.data.data
              && res.data.data.id
              && res.data.data.customer) {
            this.tireContractId = res.data.data.id;
            this.data = res.data.data.customer;
            //this.isConfirm = true;
          } else {
            this.$router.push({ name: 'routes.home' });
          }
        });
    }
  }

  private async getAddressByPostalCode() {
    if (this.data.postalCode && Utils.checkNumberHalfsize(this.data.postalCode)) {
      this.data.address1 = undefined;
      this.province = '';
      await postal_code.get(this.data.postalCode, (address: any) => {
        let finalAddress: string = '';
        if (address.city) {
          finalAddress += address.city;
        }
        if (address.prefecture) {
          this.province = address.prefecture;
          this.showProvince = true;
        }
        if (address.area) {
          finalAddress += address.area;
          this.district = address.area;
        }
        if (address.street) {
          finalAddress += address.street;
        }
        this.data.address1 = finalAddress;
        this.data.prefecture = this.province;
      });
    } else {
      const inputError = this.errors.find((e) => e.field === 'postalCode');
      if (inputError !== undefined) {
        if (inputError.isError === undefined) {
          inputError.isError = false;
          inputError.message = [];
        }
        inputError.message.push('validation.input.must_be_halfsize_number');
      }
    }
  }

  private getInputError(field: string): InputError | undefined {
    const inputError = this.errors.find((e) => e.field === field);
    return inputError ? inputError : undefined;
  }

  private confirmInfo() {
    this.errors.forEach((err) => err.isError = undefined);
    customerService.validate(this.data)
    .then((res) => {
      if (res.data.code === ResponseCodeEnum.CODE_SUCCESS) {
          this.isConfirm = true;
      }
    })
    .catch((error) => {
      if (error.response.status === 400) {
        error.response.data.errors.forEach((err: any) => {
          const inputError = this.errors.find((e) => e.field === err.field);
          if (inputError !== undefined) {
            if (inputError.isError === undefined) {
              inputError.isError = false;
              inputError.message = [];
            }
            inputError.message.push(err.defaultMessage);
          }
        });
      }
    });
  }

  private onInputChange(field: string) {
    const inputError = this.errors.find((e) => e.field === field);
    if (inputError) {
      inputError.isError = undefined;
    }
  }

  private saveCustomer() {
    if (this.data.id) {
      let queryParam: any = {
        name: 'routes.tire_register',
        query: {
          'customerId': this.data.id,
        },
      };
      if (this.tireContractId) {
        queryParam = {
          name: 'routes.tire_register',
          query: {
            'customerId': this.data.id,
            'contractId': this.tireContractId,
          },
        };
      }
      if (this.$route.query['reNew']) {
        queryParam = {
          name: 'routes.tire_register',
          query: {
            'customerId': this.data.id,
            'contractId': this.tireContractId,
            'reNew': 'true',
          },
        };
      }
      if (this.$route.query['newContract']) {
        queryParam = {
          name: 'routes.tire_register',
          query: {
            'customerId': this.data.id,
            'contractId': this.tireContractId,
            'newContract': 'true',
          },
        };
      }
      const callbackUrl = Utils.getQueryParam(this.$route.query.callbackUrl);
      if (callbackUrl) {
        queryParam.query.callbackUrl = callbackUrl;
      }
      customerService.update(this.data)
        .then((res) => {
          if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
            toastService.successMessage('view.customer.label.msg_updated');
            this.$router.push(queryParam);
          }
        });     
    } else {
      customerService.create(this.data)
        .then((res) => {
          if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
            toastService.successMessage('view.customer.label.msg_created');
            this.$router.push({
              name: 'routes.tire_register',
              query: {
                'customerId': res.data.data.id ? res.data.data.id : '',
              },
            });
          }
        });
    }
  }

  private back() {
    if (this.isConfirm === false) {
      if (this.tireContractId) {
        const callbackUrl = Utils.getQueryParam(this.$route.query.callbackUrl);
        if (callbackUrl) {
          window.location.href = callbackUrl;
        } else {
          this.$router.push({
            name: 'routes.tire_contract_detail',
            params: {
              id: this.tireContractId,
            },
          });
        }       
      } else {
        this.showModal = true;
      }
    } else {
      this.isConfirm = false;
    }
  }

  private confirmBack() {
    this.$router.push({ name: 'routes.home' });
  }

  private loadPhoneType() {
    this.data.phoneType = 1;
    customerService.getPhoneType()
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          this.options = res.data.data.map((option) => {
            if (option.text) {
              option.text = this.$t(option.text).toString();
            }
            return option;
          });
        }
      });
  }

  private changePostalCode() {
    this.showProvince = false;
  }

  private searchCustomer() {
    this.showSearchCustomer = true;
  }

  private chooseCustomer(customer: Customer) {
    if (!customer) {
      this.showModalConfirm = true;
    } else {
      this.data = customer;
      this.showSearchCustomer = false;
    }
  }
}
